import { useMemo } from 'react';

import { FormatType, getFormatter } from '@revelio/replots';

import { useCurrencyStore } from './useCurrencyStore';

/**
 * Returns a currency formatter that uses the currently selected currency from
 * the store. Applies exchange rate conversion and formats with the correct
 * currency symbol.
 */
export const useCurrencyFormatter = () => {
  const selected = useCurrencyStore((s) => s.selected);
  const code = selected?.code ?? 'USD';
  const rate = selected?.rate ?? 1;

  return useMemo(() => {
    const baseFormatter = getFormatter(FormatType.CURRENCY, {
      currencyCode: code,
    });
    return (value: number) => baseFormatter(value * rate);
  }, [code, rate]);
};
